import React from 'react';
import { Skeleton, Box, Divider, Fade } from '@mui/material';

const SiteTargetValuesSkeleton: React.FC = () => {
  return (
    <Fade in={true} timeout={800}>
      <div data-testid="loading-skeleton">
        {/* Title Section */}
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="text" width="40%" height={24} />
          <Divider sx={{ mt: 1 }} />
        </Box>

        {/* GTV Field */}
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width="15%" height={15} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={34} />
        </Box>

        {/* CTV Field */}
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width="15%" height={15} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={34} />
        </Box>

        {/* PTV Field */}
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width="15%" height={15} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={34} />
        </Box>
      </div>
    </Fade>
  );
};

export default SiteTargetValuesSkeleton;
